<template>
  <div id="AddSchoolName" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回學校名稱列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>地區:<br />
                <select v-model="inputData.cid" @change="updateCity">
                  <option
                    v-for="school in localInputData2"
                    :key="school.cid"
                    :value="school.cid"
                  >
                    {{ school.city }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div>
                <span class="red_star">＊</span>學校名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.schoolName"
                  ref="inputData.schoolName"
                  placeholder="請輸入學校名稱"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddSchoolName()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "AddSchoolName",
  props: {
    inputData2: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      localInputData2: [], // 使用組件內部的 data 來保存 inputData2 的副本
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        city: null,
        cid: null,
        schoolName: null,
      },
      inputData2: null,
      currentPage: 1,
      cid: "",
      pageSize: 10,
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    updateCity() {
      // 在這裡獲取選中的學校對象
      const selectedSchool = this.localInputData2.find(
        (school) => school.cid === this.inputData.cid
      );

      // 更新inputData.city
      if (selectedSchool) {
        this.inputData.city = selectedSchool.city;
      }
    },

    checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.inputData.cid)) {
        alert("請選擇地區");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.inputData.schoolName)) {
        alert("請輸入學校名稱");
        this.inputFlag = true;
        return;
      }
      if (this.inputData2 != null && !tools.empty(this.inputData.schoolName)) {
        const searchTerm = this.inputData.schoolName;
        // 创建一个正则表达式，i标志表示不区分大小写
        const regex = new RegExp(searchTerm, "i");
        const found = this.inputData2.some((item) => {
          return regex.test(item.schoolName);
        });

        if (found) {
          alert("該校已登錄過");
          this.inputFlag = true;
          return;
        }
      }
    },
    AddSchoolName() {
      this.checkInput();
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/AddSchoolName/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加學校名稱成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加學校名稱失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    getAllSchoolName() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllSchoolName/")
        .then((response) => {
          vm.inputData2 = Array.isArray(response.data) ? response.data : [];
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },


    close() {
      this.$emit("hideModal");
    },
  },
  mounted() {
    console.log("======created AddSchoolNameView =====");
    this.localInputData2 = JSON.parse(JSON.stringify(this.inputData2));
    this.getAllSchoolName();
    //console.log("inputData2 in AddSchoolName:", this.localInputData2);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
